import Vue from 'vue';


function debounce (func,wait,immediate=true){
    let timeout
    return function(){
        let context = this
        let args =arguments
        if(timeout){
            cleartimeout(timeout)
        }else{
            timeout = setTimeout(function(){
                // func.apply(context,args)
            },wait)
        }
    }
}

/****自定义指令***************/ 
Vue.directive('asd',{
    // bind(el,binding){
    //     let executeFunction
    //     if (binding.value instanceof Array) {
    //         const [func,time = 1000] =binding.value
    //         executeFunction = debounce(func,time)
    //     }else{
    //         executeFunction = debounce(binding.value,1000)
    //     }
    //     el.addEventListener('click',executeFunction)
    // }
})
Vue.directive('tip',{
    bind(el, binding, vnode){
    let spanObj = document.createElement('span');
        spanObj.innerHTML=binding.value
            el.appendChild(spanObj);
        Vue.nextTick(()=>{
                    if(vnode.elm.clientWidth<vnode.elm.childNodes[0].offsetWidth){
                let tip = document.createElement('div');
                tip.innerHTML=binding.value
                tip.classList.add("tip")
                let parent = vnode.elm.parentNode
                parent.appendChild(tip)
            }
                })
        // el.classList.add("z-group");
    },
    update(el, binding, vnode){

        if(binding.value==binding.oldValue){
                
            return
        }else{
            
         el.removeChild(el.firstChild);
         let spanObj = document.createElement('span');
             spanObj.innerHTML=binding.value
            el.appendChild(spanObj);
            Vue.nextTick(()=>{
                    if(vnode.elm.clientWidth<vnode.elm.childNodes[0].offsetWidth){
                let tip = document.createElement('div');
                tip.innerHTML=binding.value
                tip.classList.add("tip")
                let parent = vnode.elm.parentNode
                console.log(parent);
                parent.removeChild(parent.lastChild)
                parent.appendChild(tip)
            }
                })
            
        }
        
        // let spanObj = document.createElement('span');
        // spanObj.innerHTML=binding.value
        //     el.appendChild(spanObj);
        // Vue.nextTick(()=>{
        //             if(vnode.elm.clientWidth<vnode.elm.childNodes[0].offsetWidth){
        //         let tip = document.createElement('div');
        //         tip.innerHTML=binding.value
        //         tip.classList.add("tip")
        //         let parent = vnode.elm.parentNode
        //         parent.appendChild(tip)
        //     }
        //         })
        // el.classList.add("z-group");
    },
});